import {FormElementValues} from "@xal3xfx/react-utils";

const clientId: FormElementValues<'dropdown'> = {
    type: "dropdown",
    label: 'clientId',
    props: {filterInputAutoFocus: true},
    options: []
}

const iban: FormElementValues<'text'> = {
    type: "text",
    label: 'bankAccount',
    props: {},
}

export const formElements = {
    clientId, iban
}
